import { CopyIcon, ReferralsDropDownCSS } from './ReferralsDropDownCSS.styled'
import { useClickOutside } from 'utils/hooks'
import { useEffect, useRef, useState } from 'react'
import { Details, useDetailsState } from 'components/Atoms/Details'
import { useHotkeys } from 'react-hotkeys-hook'
import { CONTENT_TYPES } from 'constants/games/contentTypes'

import { currencyFormatter, doCopy } from 'utils'
import { useUser } from 'hooks/user/useUser'

import { config } from 'config/index'
import { useYoloModal } from 'lib/yoloModals/useYoloModal'
import { useReferralData } from 'hooks/useReferralData'
import { SingleDataLoader } from 'components/Atoms/SingleDataLoader'
import { useNavigate } from 'react-router-dom'

export const ReferralsDropDown = () => {
  const navigateTo = useNavigate()
  const { isConnected } = useUser('wallet')
  const dropdownRef = useRef(null)
  const detailsState = useDetailsState({ open: false })

  const {
    referralData: { feesEarned, usersReferred, referralCode },
    isReferralDataLoading,
  } = useReferralData()

  // start copy to clipboard logic
  const [hasCopied, setHasCopied] = useState(false)
  const makeLink = (code) => `${config.YOLO_BASE_URL}/game?referralcode=${code}`
  useEffect(() => {
    if (hasCopied) {
      const timer = setTimeout(() => {
        setHasCopied(false)
        // inputRef.current.blur()
      }, 2000)
      return () => clearTimeout(timer)
    }
  }, [hasCopied])
  const onCopy = async (event) => {
    event.preventDefault()
    event.stopPropagation()
    const copied = await doCopy(makeLink(referralCode))

    if (copied) setHasCopied(true)
  }
  // end copy to clipboard logic

  const hotKeyRef = useHotkeys('escape', () => detailsState.setOpen(false))
  useClickOutside(dropdownRef, () => detailsState.setOpen(false))

  const onLinkClick = (e, content) => {
    e.preventDefault()
    e.stopPropagation()
    navigateTo(`/game/${content}`)
    detailsState.setOpen(false)
  }

  // start user profile logic
  // open userprofile modal
  const { updateModal } = useYoloModal()
  const USER_PROFILE_MODAL_OBJ = {
    show: true,
    id: 'userProfile',
    backdropBlurred: false,
    props: {
      selectedTabId: 'user-api_tab_three',
    },
  }
  const showUserProfileModal = () => {
    detailsState.setOpen(false)
    updateModal(USER_PROFILE_MODAL_OBJ)
  }
  // end user profile logic

  const handleDisconnected = (e) => {
    if (!isConnected) onLinkClick(e, CONTENT_TYPES.REFERRALS)
  }

  return (
    <ReferralsDropDownCSS>
      <div id='referrals_menu' ref={dropdownRef} onClick={handleDisconnected}>
        <Details className='dropdown' {...detailsState} ref={hotKeyRef} isOpenBlocked={!isConnected}>
          <summary role='button'>Referrals</summary>
          <div className='menu'>
            <div className='your_referral_link'>
              <div>Your referral link:</div>
              <div className='link' onClick={onCopy}>
                <SingleDataLoader
                  loading={isReferralDataLoading}
                  data={
                    <>
                      <span>{makeLink(referralCode)}</span>
                      <CopyIcon collection='general' name={hasCopied ? 'tick' : 'copy'} masking />
                    </>
                  }
                />
              </div>
            </div>
            <div className='rewards_earned'>
              <div>Rewards earned:</div>
              <div className='value'>
                <SingleDataLoader loading={isReferralDataLoading} data={currencyFormatter(feesEarned)} />
              </div>
            </div>
            <div className='total_referees'>
              <div>Total Referees:</div>
              <div className='value'>
                {' '}
                <SingleDataLoader loading={isReferralDataLoading} data={usersReferred} />
              </div>
            </div>
            <div className='links'>
              <div className='link' onClick={showUserProfileModal}>
                Go to My Referrals
              </div>
              <div className='link' onClick={(e) => onLinkClick(e, CONTENT_TYPES.REFERRALS)}>
                Go to Referrals page
              </div>
            </div>
          </div>
        </Details>
      </div>
    </ReferralsDropDownCSS>
  )
}
